import React from "react";
import Button from "../Button/Button";
import CSS from "./styles.module.css";

// Animate on Scroll
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const ActionBox = ({ icon, content, button, link }) => {
	useEffect(() => {
		AOS.init({ duration: 1200, delay: 100 });
	}, []);

	return (
		<a href={link} className={CSS.Container}>
			<div className={CSS.ActionBox} data-aos="fade-up">
				<li className="material-symbols-round icon">{icon}</li>
				{content}
				<Button variant="SmallButton" rightIcon="chevron_right">
					{button}
				</Button>
			</div>
		</a>
	);
};

export default ActionBox;
